<template>
  <div class="home">
    <NavigationBar />
    <Breadcrumb breadcrumbText="About Us" />
    <History />
    <Feedback />
    <Team />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import History from "@/components/History.vue";
import Feedback from "@/components/Feedback.vue";
import Team from "@/components/Team.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "about",
  components: {
    NavigationBar,
    Breadcrumb,
    History,
    Feedback,
    Team,
    Footer
  }
};
</script>
